<template>
    <v-dialog
    v-model="show"
    persistent
    width="480">
   
    <v-card color="light_gray">
        <v-toolbar class="mid-font" color="primary" dense dark >
            <v-icon left >mdi-cog</v-icon><span class="va-underline">{{state=='new'?'New':'Edit'}} ModuleName</span>
            <v-spacer/>
            <v-icon  @click="emitToParent('close')">mdi-close</v-icon>
          </v-toolbar>
          <v-card-text class="pa-4 def-font">
            
          </v-card-text>
          <v-card-actions>
              <!-- <v-btn small color="error" v-if="state=='update'" @click="Remove()">
                  Remove
              </v-btn> -->
              <v-spacer/>
              <v-btn small color="secondary" @click="validate()">
                  {{state=='new'?'ADD':'SAVE'}} 
              </v-btn>
          </v-card-actions>
    </v-card>
  
  </v-dialog>
</template>

<script>
import { API_MIXINS } from '@/mixins/api_mixins.js'
export default {
    mixins: [API_MIXINS],
  props: {
      show:{
          type: Boolean,
          default: false
      },
      state: {
          type: String,
          default: 'new'
      },

  },
  data () {
      return {
        valid: true,
      }
    },
//   watch: {
    
//   },
  computed:{
    
  },
  methods: {
   emitToParent (action) {
      this.$emit('DialogEvent', action)
    }
  }
}
</script>
